import { CopyButton } from "@/components/ui/CopyButton";
import { Breadcrumbs, Typography } from "@mui/material";

type Props = {
  id: string;
  revision: number;
};

export function RevisionBreadcrumbs({ id, revision }: Props) {
  return (
    <Breadcrumbs separator="·">
      <CopyButton text={id}>
        <Typography>{`Revision ID: ${id}`}</Typography>
      </CopyButton>
      <Typography>{`Revision: ${revision}`}</Typography>
    </Breadcrumbs>
  );
}
